<template>
  <!-- 卫星选择 -->
  <div class="checkBox">
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item :name="panelIndex">
        <template slot="title">
          <div class="satelliteTitle">
            <el-checkbox class="satelliteCheck" :indeterminate="isIndeterminate" v-model="checkAll"
              @change="handleCheckAll">全选</el-checkbox>
            <span class="satelliteName">{{ panelName }}</span>
          </div>
        </template>
        <div class="satelliteItem">
          <div class="allCheckWrap">
            <el-checkbox-group v-model="selectedData" @change="handleCheckedSateChange">
              <el-checkbox v-for="item in contentDataPage" :label="item.id" :key="item.id">
                {{ item.satelliteName }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
let acceptData = [];
export default {
  name: "checkBox",
  props: {
    panelIndex: String,
    panelName: String,
    contentData: Array
  },
  data() {
    return {
      activeNames: '0',
      checkAll: false,
      contentDataPage: [],
      selectedData: [],
      isIndeterminate: true
    };
  },
  created() {
    this.contentDataPage = this.contentData;
    // console.log("卫星系列数据：", this.contentDataPage);
  },
  mounted() { },
  methods: {
    //   折叠面板触发
    handleChange(value) {
      // console.log("折叠面板触发：", value);
      return false;
    },
    //   系列卫星全选
    handleCheckAll(val) {
      console.log(this.contentDataPage);
      let checked = this.contentDataPage.map(item => {
        return item.id;
      });
      this.selectedData = val ? checked : [];
      this.isIndeterminate = false;
      let sendIdArray = [];
        this.contentDataPage.map(item=>{
          sendIdArray.push(item.id)
        })
      this.$emit('currentCheckItem', sendIdArray);
    },
    // 单一卫星选择
    handleCheckedSateChange(value) {
      // console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.contentDataPage.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.contentDataPage.length;
      this.$emit('currentCheckItem', value);
    }
  },
};
</script>

<style lang="scss" scoped>
.checkBox {
  .satelliteTitle {
    width: 100%;
    // background-color: rgb(220, 220, 220);
    height: 36px !important;
    line-height: 36px;

    .satelliteCheck {
      padding-left: 10px;
    }

    .satelliteName {
      margin-left: 10px;
      // font-weight: bold;
      float: right;
      padding-right: 20px;
    }
  }

  .satelliteItem {
    padding: 5px 10px;
    margin-top: 5px;
    box-sizing: border-box;
    border-bottom: 1px dashed #eee;
    display: flex;

    .checkName {
      flex: 1;
    }

    .allCheckWrap {
      flex: 9;

      .el-checkbox {
        margin-right: 10px !important;
      }
    }
  }
}
</style>
